<div class="mb-progress-spinner"
  [class.mb-progress-spinner--overlay]="overlay"
  [class.mb-progress-spinner--inline]="!overlay">
  <div
    class="mb-progress-spinner__circle"
    [class.mb-progress-spinner__circle--accent]="color === 'accent'"
    [style.width.px]="diameter"
    [style.height.px]="diameter"
    [style.border-width.px]="resolvedStrokeWidth">
  </div>
</div>
